import React from 'react';
import { Info, CheckCircle, XCircle, AlertTriangle } from 'lucide-react';

const StatusBadge = ({ type, children, showIcon = true }) => {
  const types = {
    info: {
      bg: 'bg-blue-500/10',
      text: 'text-blue-400',
      border: 'border-blue-500/30',
      icon: Info
    },
    success: {
      bg: 'bg-accent-green/10',
      text: 'text-accent-green',
      border: 'border-accent-green/30',
      icon: CheckCircle
    },
    error: {
      bg: 'bg-red-500/10',
      text: 'text-red-400',
      border: 'border-red-500/30',
      icon: XCircle
    },
    warning: {
      bg: 'bg-accent-green/10',
      text: 'text-accent-white',
      border: 'border-accent-green/30',
      icon: AlertTriangle
    }
  };

  const config = types[type] || types.info;
  const Icon = config.icon;
  
  return (
    <div className={`
      px-5 py-4 rounded-xl border-2 
      text-sm text-start
      transition-all duration-200
      flex items-center justify-center gap-3
      ${config.bg} ${config.text} ${config.border}
    `}>
      {showIcon && <Icon size={20} />}
      <span>{children}</span>
    </div>
  );
};

export default StatusBadge;